import { AxiosRequestConfig } from "axios";
import { timeoutOverrides } from "./timeoutOverrides";

export interface ApiTimeoutModel {
    Url: string;
    Timeout: number | ((param: AxiosRequestConfig) => number);
    /** Defaults to exact URL matching when omitted. */
    Match?: "exact" | "prefix";
}

const TimeoutOverrides: ApiTimeoutModel[] = [...timeoutOverrides];

export { TimeoutOverrides };
